<template>
  <div class="tag-list-container">
    <el-card>
      <div class="toolbar">
        <el-button type="primary" @click="addTag">添加标签</el-button>
      </div>
      
      <el-table :data="tagList" border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="content" label="标签内容"></el-table-column>
        <el-table-column prop="roleName" label="所属角色"></el-table-column>
        <el-table-column prop="workName" label="所属作品"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="editTag(scope.row)">编辑</el-button>
            <el-button type="text" @click="deleteTag(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div v-if="tagList.length === 0" class="empty-state">
        <i class="el-icon-tags"></i>
        <p>暂无标签数据</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'TagListView',
  data() {
    return {
      tagList: []
    };
  },
  created() {
    this.loadTagList();
  },
  methods: {
    loadTagList() {
      // 实际项目中应调用API加载数据
      // 这里使用模拟数据
      this.tagList = [
        {
          id: 1,
          content: '主角',
          roleName: '角色A',
          workName: '作品A'
        },
        {
          id: 2,
          content: '反派',
          roleName: '角色B',
          workName: '作品A'
        }
      ];
    },
    addTag() {
      this.$message.info('添加标签功能待实现');
      // 实际项目中应跳转到标签添加页面
      // this.$router.push('/tag-form');
    },
    editTag(row) {
      this.$message.info(`编辑标签: ${row.content}`);
    },
    deleteTag(row) {
      this.$confirm(`确定删除标签"${row.content}"吗?`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 实际项目中应调用API删除标签
        this.tagList = this.tagList.filter(tag => tag.id !== row.id);
        this.$message.success('标签删除成功');
      }).catch(() => {
        // 取消删除
      });
    }
  }
};
</script>

<style scoped>
.empty-state {
  text-align: center;
  padding: 50px 0;
}

.empty-state i {
  font-size: 60px;
  color: #c0c4cc;
  margin-bottom: 20px;
}

.empty-state p {
  color: #889099;
}

.toolbar {
  margin-bottom: 15px;
}
</style>